<template>
  <div>
    <md-card>
      <!-- <md-card-media> -->
        <!-- <img src="@/assets/coverDefault.png" alt="People"> -->
        <!-- <minimap-markers style="height: 150px;" mode="fixed" :place="place" /> -->
      <!-- </md-card-media> -->

      <md-card-header>
        <h2 class="md-title">{{ place.name }}</h2>
        <div class="md-subhead">
          <span>{{ place.weight }} capítulos</span>
        </div>
      </md-card-header>

      <md-card-content>
        {{ place.description || "Descrição" }}
      </md-card-content>
      <md-card-actions>
        <md-button class="md-primary md-raised" :to="{ name: 'place', params: { id: place.id } }">
          Ver mais
        </md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
// import minimapMarkers from "@/components/drawer/maps/minimapMarkers";

export default {
  props: ["place"],
  components: {
    // minimapMarkers
  }
}
</script>

<style scoped>
</style>
